import { Popover, VStack, Checkbox, CheckboxGroup } from '@chakra-ui/react';
import { FilterPopoverButton, FilterPopoverContent } from './FilterPopover';
import { ICourse } from '@/shared/ICourse';

export const CheckboxFilterArchived = (props: {
  allCourses: ICourse[];
  value: string[] | undefined;
  onSetFilter: (value: string[] | undefined) => void;
}) => {

  const options = [
    {
      label: 'Active Courses',
      value: 'active',
      count: props.allCourses?.filter(course => !course.archived).length || 0
    },
    {
      label: 'Archived Courses',
      value: 'archived',
      count: props.allCourses?.filter(course => course.archived).length || 0
    }
  ].filter(option => option.count > 0); // Only show options that exist

  const hasSelection = (props.value?.length || 0) > 0;

  return (
    <Popover isLazy placement="bottom-start">
      <FilterPopoverButton label="Archived" selected={hasSelection} />
      <FilterPopoverContent>
        <CheckboxGroup value={props.value || []} onChange={(v) => props.onSetFilter(v.length > 0 ? v as string[] : undefined)}>
          <VStack spacing="2" align="stretch">
            {options.map((option) => (
              <Checkbox key={option.value} value={option.value} colorScheme="blue">
                {option.label} ({option.count})
              </Checkbox>
            ))}
          </VStack>
        </CheckboxGroup>
      </FilterPopoverContent>
    </Popover>
  );
};
